
import React from "react";
import { Elements } from "../Elements";
import { Utils } from "../../../utils";
import { Classname, StringHelper } from "@rivtn/noseur";
import * as ReactRouterDom from "react-router-dom";
import { IAnalyticsData } from "../../../services";

export interface AnalCardProps {
    desc: string;
    icon?: string;
    title?: string;
    analKey?: string;
    cardColor?: string;
    currencySign?: string;
    anal?: IAnalyticsData; // ;)
    to?: ReactRouterDom.To;
    daysDifference?: number;
    style?: React.CSSProperties;
}

function AnalCard(props: AnalCardProps) {

    const { desc, title, icon, anal, analKey, style, cardColor, currencySign, daysDifference = 0, to = "" } = props;
    const compoundElement = (to ? ReactRouterDom.NavLink : "div");

    return React.createElement(compoundElement, {
        to,
        className: "card",
        style: (cardColor ? { ...style, "--cardColor": cardColor } as any : style)
    },
        (<div className="top">
            <div className="ind">
                {icon && (<i className={icon} />)}
                <span className="lined-limit">{title}</span>
            </div>
            <div className={Classname.build("trend",
                (anal ? { "p": anal?.percentage > 0, "n": anal?.percentage < 0, "b": anal?.percentage == 0 } : {}))}>
                {Elements.TREND_ICON}
                <span className="lined-limit">{anal?.percentage} %</span>
            </div>
        </div>), (<div className="middle">
            {!anal ? (<i className="fa fa-spinner fa-spin" />) : (<span className="v lined-limit">{currencySign} {analKey ? (anal as any)?.[analKey]: StringHelper.toPresentableMoneyValue(anal?.value!)}</span>)}
            <span className="l lined-limit">{desc.replaceAll("${days}", "" + daysDifference)}</span>
        </div>)
    );
}


export default AnalCard;